<template>
  <div>
    <a-drawer :title="`${actType}视频到快手广告主`" :width="720" :visible="showUpload" :body-style="{ paddingBottom: '80px' }"
      @close="close" :maskClosable="false">

     
      <a-form-model ref="form" :model="model" :rules="rules">
        <a-spin :spinning="loading" tip="Loading..." size="large" >


            <a-form-model-item label="上传模式">
              <a-radio-group v-model="upload_type" @change="changeUploadType">
                <a-radio-button :value="item.id" v-for="item in uploadTypes" :key="item.id" >{{ item.name }}</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <a-form-model-item label="广告主" prop="advertiser_ids" help="选择广告主后才能上传视频" v-if="upload_type == 2">
              <advs-select v-model="model.advertiser_ids" :max-tag-count="20" type="kuaishou" @change="changeAdvertiserIds"/>
            </a-form-model-item>
            <a-form-model-item label="广告主" prop="advertiser_id" help="选择广告主后才能上传视频" v-else>
              <adv-select v-model="model.advertiser_id" :max-tag-count="1" type="kuaishou" />
            </a-form-model-item>

            <template v-if="upload_type === 2">
              <a-form-model-item label=""  help='' style="border: 1px solid #87e8de;padding:20px">
                <a-tabs :default-active-key="0" size="small" tabPosition="left"  v-if="advertisers.length>0" >
                  <a-tab-pane  :tab="advertiser.name" v-for="(advertiser,index) in advertisers" :key="index" >
                    <a-form-model-item label="广告主ID">
                      <a-input v-model="advertisers[index].advertiser_id" disabled />
                    </a-form-model-item> 
                    <a-form-model-item label="是否显示到快手主页">
                      <a-switch default-checked v-model="advertisers[index].shield_backward_switch" />
                    </a-form-model-item>
                    <a-form-model-item label="广告主素材">
                      <kuaishou-upload v-model="advertisers[index].file_url" @afterUpload="handleAfterUpload" :advertiser_id="advertisers[index].id" :ref="'uploadRef_' + index"/>
                    </a-form-model-item>
                  </a-tab-pane>
      
                </a-tabs>
              </a-form-model-item>
            </template>

            <template v-else>
              <a-form-model-item label="是否显示到快手主页" prop="shield_backward_switch">
                <a-switch default-checked v-model="model.shield_backward_switch" />
              </a-form-model-item>
              <a-form-model-item label="素材" class="upload-model-item" prop="file_url" help="">
                <kuaishou-upload v-model="model.file_url" @afterUpload="handleAfterUpload" :advertiser_id="model.advertiser_id" ref="uploadRef"/>
              </a-form-model-item>
            </template>
        </a-spin>
      </a-form-model>

      <div :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button type="primary" @click="handleClear" :disabled="loading" :style="{ marginRight: '8px' }">
          继续上传
        </a-button>
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          关闭
        </a-button>
        <!-- <a-button type="primary" @click="submit" :disabled="loading">确定</a-button> -->
      </div>


    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'Upload';
</style>

<script>
import Upload from './Upload'

export default Upload
</script>
